import React from "react";
import { motion } from "framer-motion";

const pageVariants = {
  initial: { rotateY: 90, opacity: 0 },
  in: { rotateY: 0, opacity: 1 },
  out: { rotateY: -90, opacity: 0 },
};

const pageTransition = {
  type: "spring",
  stiffness: 80,
  damping: 20,
};

const counterStyle = {
  background: "#1f2937", // dark gray card
  borderRadius: "14px",
  padding: "24px",
  textAlign: "center",
  boxShadow: "0 8px 30px rgba(0,0,0,0.2)",
  flex: "1 1 220px",
};

const Industries_Portfolio = () => (
  <motion.div
    initial="initial"
    animate="in"
    exit="out"
    variants={pageVariants}
    transition={pageTransition}
    style={{
      minHeight: "70vh",
      padding: "50px 20px",
      backgroundColor: "#000000", // black background
      fontFamily: "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Arial",
      color: "#ffffff", // default white text
    }}
  >
    {/* Gradient Title */}
    <h1
      className="coMTHA"
      style={{
        fontSize: "clamp(1.8rem, 4.5vw, 3rem)",
        color: "#ffffff",
        marginBottom: "40px",
        textAlign: "center",
        fontFamily: "'Manrope', sans-serif",
        fontWeight: 700,
        background: "linear-gradient(45deg, #FF6B35, #4a90e2)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        backgroundClip: "text",
        textShadow: "0 0 24px rgba(74, 144, 226, 0.25)",
      }}
    >
      Our Portfolio
    </h1>

    {/* Short Description */}
    <p
      style={{
        maxWidth: "900px",
        margin: "0 auto 40px",
        textAlign: "justify", // ✅ justified
        fontSize: "16px",     // ✅ 16px
        lineHeight: 1.7,
      }}
    >
      Zyntro Software Solutions Pvt. Ltd. proudly serves a growing digital
      ecosystem across India. Our platforms empower businesses, distributors,
      retailers, and customers nationwide.
    </p>

    {/* Counter Section */}
    <section
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "20px",
        maxWidth: "1100px",
        margin: "0 auto 50px",
      }}
    >
      <div style={counterStyle}>
        <h2 style={{ fontSize: "34px", color: "#FF6B35" }}>3K+</h2>
        <p>Retailers</p>
      </div>

      <div style={counterStyle}>
        <h2 style={{ fontSize: "34px", color: "#4a90e2" }}>400+</h2>
        <p>Distributors</p>
      </div>

      <div style={counterStyle}>
        <h2 style={{ fontSize: "34px", color: "#16a34a" }}>1.5 Lakh+</h2>
        <p>Customers</p>
      </div>
    </section>

    {/* Content + Map */}
    <section
      style={{
        maxWidth: "1200px",
        margin: "0 auto",
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: "30px",
      }}
    >
      {/* Left Content */}
      <div style={{ flex: "1 1 420px" }}>
        <h3 style={{ fontSize: "26px", color: "#ffffff" }}>
          Pan-India Digital Reach
        </h3>

        <p style={{ lineHeight: 1.7, fontSize: "16px", textAlign: "justify" }}>
          Zyntro Software Solutions Pvt. Ltd. has established a strong and
          reliable presence across all Indian states. Our platforms are designed
          to scale seamlessly, enabling retailers and distributors to operate
          efficiently while delivering superior digital experiences to
          customers.
        </p>

        <p style={{ lineHeight: 1.7, fontSize: "16px", textAlign: "justify" }}>
          With over <strong>3,000+ retailers</strong> and{" "}
          <strong>400+ distributors</strong>, we have built a trusted ecosystem
          serving more than <strong>1.5 lakh customers</strong>. Our solutions
          focus on security, performance, automation, and real-time insights,
          helping businesses grow faster.
        </p>

        <p style={{ lineHeight: 1.7, fontSize: "16px", textAlign: "justify" }}>
          From metro cities to remote regions, Zyntro continues to deliver
          cutting-edge software solutions that power digital transformation
          across industries.
        </p>
      </div>

      {/* Right Map */}
      <div
        style={{
          flex: "1 1 420px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <img
          src="/images/india.png"
          alt="Zyntro Pan India Presence"
          style={{
            width: "100%",
            maxWidth: "480px",
            borderRadius: "16px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
          }}
        />
      </div>
    </section>
  </motion.div>
);

export default Industries_Portfolio;
